import React from 'react';
import { motion } from 'framer-motion';

const images = [
  'https://images.unsplash.com/photo-1527799820374-dcf8d9d4a388?auto=format&fit=crop&q=80&w=800',
  'https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?auto=format&fit=crop&q=80&w=800',
  'https://images.unsplash.com/photo-1562322140-8baeececf3df?auto=format&fit=crop&q=80&w=800'
];

export default function Gallery() {
  return (
    <section id="gallery" className="py-24 bg-brand-light">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-4">Our Space & Work</h2>
          <div className="w-16 h-1 bg-brand-accent mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {images.map((src, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`aspect-square overflow-hidden ${index === 1 ? 'md:mt-12' : ''}`}
            >
              <img 
                src={src} 
                alt={`Salon Gallery ${index + 1}`} 
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </motion.div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <button className="border-b-2 border-brand-dark text-brand-dark pb-1 text-sm uppercase tracking-widest font-semibold hover:text-brand-accent hover:border-brand-accent transition-colors">
            Follow our Instagram
          </button>
        </div>
      </div>
    </section>
  );
}